"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPreferences = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const LocalStorage_1 = require("../../../utility/LocalStorage");
const getActiveWorkspace_1 = require("../utilities/getActiveWorkspace");
const mapNucleiFormatting_1 = require("../utilities/mapNucleiFormatting");
function setPreferences(draft, action) {
    const localData = (0, LocalStorage_1.getLocalStorage)('nmr-general-settings');
    const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
    if (action.payload) {
        const { formatting, ...restPreferences } = action.payload;
        draft.workspaces[draft.workspace.current] = {
            ...currentWorkspacePreferences,
            ...restPreferences,
            formatting: (0, mapNucleiFormatting_1.mapNucleiFormatting)(formatting),
        };
    }
    if (draft.workspaces[draft.workspace.current].source === 'user') {
        draft.workspaces[draft.workspace.current].version++;
        (0, LocalStorage_1.storeData)('nmr-general-settings', JSON.stringify({
            ...localData,
            workspaces: {
                ...localData.workspaces,
                [draft.workspace.current]: draft.workspaces[draft.workspace.current],
            },
        }));
    }
    draft.originalWorkspaces[draft.workspace.current] = (0, cloneDeep_1.default)(draft.workspaces[draft.workspace.current]);
}
exports.setPreferences = setPreferences;
